import { api } from '@/http/constants';
import fetchWrapper from '@/http/fetchWrapper';
import type { MfaSetupRequest, MfaSetupResponse } from '@eye-able/types';
import { useMutation } from '@tanstack/react-query';
import { toMfaError } from './mfaError';

/** A fresh secret for the authenticator app; in force only once confirmed. */
export function useStartTotpSetup() {
  return useMutation({
    // The secret must not linger in the cache.
    gcTime: 0,
    mutationFn: (body: MfaSetupRequest) =>
      fetchWrapper
        .post<MfaSetupResponse>(api.mfaSetup, body)
        .catch((error: unknown) => {
          throw toMfaError(error);
        }),
  });
}
